import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { conf } from "./utils/config";
import { Provider } from "react-redux";
import store from "./app/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AuthProvider from "./context/AuthProvider";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const defaultConfig: AxiosRequestConfig = {
  baseURL: conf("BACKEND_API_DASHBOARD_URL") || conf("BACKEND_API_URL"),
};

const GOOGLE_ID = process.env.REACT_APP_GOOGLE_APP_CLIENT_ID || "";

axios.interceptors.request.use(
  (config) => {
    // Verificar si esta petición proviene de una instancia personalizada
    // Si es así, NO modificar el baseURL en absoluto
    const isCustomInstance = (config as any).__isCustomInstance || 
                             (config.adapter && (config.adapter as any).__isCustomInstance);
    
    // Si es una instancia personalizada, NO tocar el baseURL (incluso si es undefined)
    // Solo establecer baseURL si NO es una instancia personalizada Y no está configurado
    if (!isCustomInstance && !config.baseURL) {
      config.baseURL = defaultConfig.baseURL;
    }
    
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      } as AxiosRequestHeaders;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <GoogleOAuthProvider clientId={GOOGLE_ID}>
          <App />
        </GoogleOAuthProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
